interface FlashOptions {
  autoHide?: boolean;
  autoHideTimeout?: number;
}

interface ShowParams {
  type: 'notice' | 'error' | 'info' | 'warning';
  text: string;
  options?: FlashOptions;
}

export const show = (
  type: ShowParams['type'],
  text: ShowParams['text'],
  options?: ShowParams['options']
) =>
  document.dispatchEvent(
    new CustomEvent('reactFlashNotice:show', {
      detail: { type, text, options },
    })
  );

export const success = (text: string, options?: FlashOptions) =>
  show('notice', text, options);
export const error = (text: string, options?: FlashOptions) =>
  show('error', text, options);
export const info = (text: string, options?: FlashOptions) =>
  show('info', text, options);
export const warning = (text: string, options?: FlashOptions) =>
  show('warning', text, options);

export const hide = () =>
  document.dispatchEvent(new CustomEvent('reactFlashNotice:hide'));
